/** ScreenSkeleton: the page while a screen's code loads. A heading and one table card where every screen puts them, so a route change never paints an empty page. */
import { Card, CardHeader, Skeleton, TableSkeleton } from "../kit";

export function ScreenSkeleton() {
  return (
    <div className="flex w-full flex-col gap-7">
      <Skeleton className="h-[34px] w-40" />
      <Card className="w-full">
        <CardHeader>
          <Skeleton className="h-4 w-28" />
        </CardHeader>
        <div className="relative w-full rounded-xl bg-card p-1.5 shadow-frame-input">
          <TableSkeleton label="the page" rows={8} />
        </div>
      </Card>
    </div>
  );
}
